import './DashLineChart.css';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartOptions,
    Filler
} from 'chart.js';
import { ILineChartData } from '../../../interfaces/type1/ILineChartData';
import { useRealoadOnThemeToogle } from '../../../components/hooks/useRealodOnThemeToogle';
import { useColors as useGrayColors } from '../../../components/hooks/useColors';


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);


export default function DashLineChart(props: { Data: ILineChartData }) {

    let fontColor = useRealoadOnThemeToogle();

    let { getColors } = useGrayColors();


    let getDataSet = () => {

        if (props.Data.DataSets.SeriesGroupFunction) {
            let sets = props.Data.DataSets.SeriesGroupFunction();
            return sets.Select(d => {
                let index = 0;

                for (let i = 0; i < sets.length; i++) {
                    if (d.Key == sets[i].Key) {
                        index = i;
                        break;
                    }
                }

                return {
                    datalabels: {
                        display: false,
                        color: fontColor,
                        font:
                        {
                            family: 'Oswald'
                        },

                    },
                    label: d.Key,
                    data: d.Data.Select(s => s.Total),
                    borderColor: d.ColorIndex != undefined ? getColors(10)[d.ColorIndex!] : getColors(10)[index],
                    backgroundColor: d.ColorIndex != undefined ? getColors(10)[d.ColorIndex!] : getColors(10)[index],
                    borderWidth: 4,
                    tension: 0.4,
                    pointRadius: 0,
                    pointHoverRadius: props.Data.EnableTooltip ? 7 : 5,
                    fill: true
                }

            });
        }
        else {
            return [{
                datalabels: {
                    display: false,
                    color: fontColor,
                    font:
                    {
                        family: 'Oswald'
                    },

                },
                label: props.Data.DataSets.Title,
                data: props.Data.DataSets.Data.Select(s => s.Total),
                borderColor: getColors(props.Data.DataSets.Data.Count()),
                backgroundColor: getColors(props.Data.DataSets.Data.Count()),
                borderWidth: 4,
                tension: 0.4,
                pointRadius: 0,
                fill: false,

            }]
        }
    }


    const data = {
        labels:
            props.Data.LabelFormat ? props.Data.DataSets.Data.Select(s => props.Data.LabelFormat!(s.Group)).Distinct() :
                props.Data.DataSets.Data.Select(s => s.Group).Distinct(),
        datasets: getDataSet(),
    };



    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            filler: {
                propagate: true
            },
            datalabels: {
                anchor: 'start',
                align: 'left',
                clip: false,
                padding: {
                    top: 10,
                    left: -20,
                    bottom: 10,
                },
            },
            tooltip: {
                enabled: props.Data.EnableTooltip ?? true,
                callbacks: {
                    title: (tooltipItems) => {
                        const labelIndex = tooltipItems[0].dataIndex;
                        return data.labels[labelIndex];
                    },
                    label: (tooltipItem) => {

                        const index = tooltipItem.dataIndex;
                        const total = tooltipItem.dataset.data[index];
                        if (props.Data.ToolTipFormatter) {
                            if (props.Data.DataSets.SeriesGroupFunction) {
                                let sets = props.Data.DataSets.SeriesGroupFunction();

                                let item = sets.find(s => s.Key == tooltipItem.dataset.label);

                                if (item)
                                    return props.Data.ToolTipFormatter(item.Data[tooltipItem.dataIndex]);
                            }
                            return props.Data.ToolTipFormatter(props.Data.DataSets.Data[tooltipItem.dataIndex]);

                        } else {
                            return `Total ${total}`;
                        }


                    }
                },
            },
            legend: {
                display: false,
                labels: {
                    color: fontColor,
                    font:
                    {
                        family: 'Oswald'
                    }
                },
            },
            title: {
                display: false,
                text: props.Data.Title,
                color: fontColor,
                font:
                {
                    family: 'Oswald',
                    size: 19

                },
                padding: {
                    bottom: 25
                }

            },
        },
        scales: {
            x: {
                ticks: {
                    color: fontColor,



                    font:
                    {
                        family: 'Oswald'
                    }
                },
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    color: fontColor,

                    font:
                    {
                        family: 'Oswald'
                    }
                },

                grid: {
                    display: false,
                    drawTicks: true,
                    
                },
            },

        },
    };

   if (props.Data.XTickFormatter) {


        if (!!props.Data.Horizontal) {
            options.scales!.y!.ticks!.callback = function (v: any) {

                if(!props.Data.DataSets.Data.Any())
                    return "";

                const item = props.Data.DataSets.Data[v];
                const label = item.Group;
                if (props.Data.XTickFormatter) return props.Data.XTickFormatter(item);
                return `${label}`;
            };
        } else {
            options.scales!.x!.ticks!.callback = function (v: any) {

                if(!props.Data.DataSets.Data.Any())
                    return "";

                const item = props.Data.DataSets.Data[v];
                const label = item.Group;
                if (props.Data.XTickFormatter) return props.Data.XTickFormatter(item);
                return `${label}`;
            };
        }
    }


    if (props.Data.YTickFormatter) {
        if (!!props.Data.Horizontal) {
            options.scales!.x!.ticks!.callback = function (v: any) {

                   if(!props.Data.DataSets.Data.Any())
                    return "";


                if (props.Data.YTickFormatter)
                    return props.Data.YTickFormatter(v);
                return `${v}`;
            };
        } else {
            options.scales!.y!.ticks!.callback = function (v: any) {

                   if(!props.Data.DataSets.Data.Any())
                    return "";

                   
                if (props.Data.YTickFormatter)
                    return props.Data.YTickFormatter(v);
                return `${v}`;
            };
        }


    }


    return (
        <div className='DashLineChartComponent'>
            <Line data={data} options={options} />
        </div>
    );
};

